export class GetArtifactAndOperationsParams {
  operation_target: string;
  artifact_id: string;
  get_original_artifact: boolean;
  locale: string;
  template_group_id: string;
  timezone_offset: number;
}
